import * as Sentry from '@sentry/browser'
import { getSnapshot } from 'mobx-state-tree'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import { Store } from './models/store'
import { createStore, store } from './utils/createStore'
import { env } from './utils/env'
import { Provider } from 'mobx-react'
import { PatientIdStore } from './stores/PatientIdStore'

Sentry.init({ dsn: env.REACT_APP_SENTRY_DSN, environment: 'webtips-gui-web', enabled: env.NODE_ENV === 'production' })

const initialState = {}

const stores = {
  patientIdStore: new PatientIdStore(),
}

function renderApp(CurrentApp: typeof App, currentStore: typeof Store.Type) {
  ReactDOM.render(<Provider {...stores}>
    <CurrentApp store={currentStore} /></Provider>, document.getElementById('root'))
}

// Initial render
renderApp(App, createStore(initialState))

// Connect HMR
if ((module as any).hot) {
  (module as any).hot.accept(['./models/store'], () => {
    // Store definition changed, recreate a new one from old state
    renderApp(App, createStore(getSnapshot(store)))
  });

  (module as any).hot.accept(['./App'], () => {
    // Componenent definition changed, re-render app
    renderApp(App, store)
  })
}



// WEBPACK FOOTER //
// ./src/index.tsx